import { Record as record } from 'immutable';
import _ from 'lodash';

import Station from './Station';
import AdjustedTime from './AdjustedTime';
import { resolve } from '../helpers/LinkMapper';

const defaults = {
    id: null,
    station: new Station(),
    time: new AdjustedTime(),
    platform: null,
    added: false,
    cancelled: false,
    pattern: null,
    boardAlight: null
};

class StationStop extends record(defaults) {
    static fromJSON (json) {
        json = json || {};

        const station = resolve(json.station).as(Station);
        const time = resolve(json.time).as(AdjustedTime);
        const platform = resolve(json.platform).with(String);
        const added = resolve(json.added).with(Boolean);
        const cancelled = resolve(json.cancelled).with(Boolean);
        const pattern = resolve(json.pattern).with(String);
        const boardAlight = resolve(json.boardAlight).with(String);

        let result = { station, time, platform };

        if (added) { result.added = added; }
        if (cancelled) { result.cancelled = cancelled; }
        if (pattern) { result.pattern = pattern; }
        if (boardAlight) { result.boardAlight = boardAlight; }

        return new StationStop(result);
    }

    isAdjustedTime () {
        if (!this.time) {
            return false;
        }
        return !this.getTime().isSame(this.getTime(false));
    }

    isDelayed () {
        return this.getIn(['time', 'delayed']);
    }

    getTime (adjusted = true) {
        return _.result(this.getIn(['time', adjusted ? 'adjustedTime' : 'scheduledTime']), 'clone');
    }
}

export default StationStop;



// WEBPACK FOOTER //
// ./src/records/StationStop.js